import { render, staticRenderFns } from "./CommunityPage_Communities.vue?vue&type=template&id=13fc187c&scoped=true&"
import script from "./CommunityPage_Communities.vue?vue&type=script&lang=js&"
export * from "./CommunityPage_Communities.vue?vue&type=script&lang=js&"
import style0 from "./CommunityPage_Communities.vue?vue&type=style&index=0&id=13fc187c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13fc187c",
  null
  
)

export default component.exports